let elementFromHtml;
if (typeof window === "undefined") {
    elementFromHtml = function() {
        console.warn("Do not use it in Node.js");
    };
} else {
    const fragmentRE = /^\s*<(\w+|!)[^>]*>/, table = document.createElement("table"), tableRow = document.createElement("tr"), div = document.createElement("div"), containers = {
        tr: document.createElement("tbody"),
        tbody: table,
        thead: table,
        tfoot: table,
        td: tableRow,
        th: tableRow
    };
    elementFromHtml = function(htmlStr) {
        htmlStr = htmlStr.trim();
        const [name] = htmlStr.match(fragmentRE);
        const container = containers[name] || div;
        container.innerHTML = htmlStr;
        return container.firstElementChild;
    };
}
export default elementFromHtml;
